export default "__VITE_ASSET__CALKFJcC__"